'use strict';

import * as dom from './dom.js';

const disableLink = (event) => {
    event.preventDefault();
}

export default function () {
    let linkDisabled = document.querySelectorAll('.js-disable-link');
    if (linkDisabled) { return }

    if (linkDisabled[0].nodeName !== "A") {
        linkDisabled = document.querySelectorAll('.js-disable-link>a');
    }

    dom.forEachEl(linkDisabled, (el) => {
        el.addEventListener('click', disableLink);
    });
}
